import { FilterService } from "primeng/api";
import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomValidators } from 'ng2-validation';
import { AuthService } from 'src/app/services/auth.service';
import { MustMatch, lettersWithOptionalSpaceValidator } from 'src/app/_helpers/must-match.validator';
import { TokenStorageService } from '../../services/token-storage.service';
import { RoleService } from 'src/app/services/role.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { maxYearFunction } from 'src/app/_helpers/utility';
import { HeaderComponent } from '../header/header.component';
import { CityService } from 'src/app/manage/city/service/city.service';
import { UserService } from 'src/app/services/user.service';
import { CountryService } from 'src/app/manage/country/service/country.service';
import { StateService } from 'src/app/manage/state/service/state.service';
import { BannerService } from 'src/app/services/banner.service';
import { CategoryService } from 'src/app/services/category.service';
import * as moment from 'moment';
import { Subscription, timer } from 'rxjs';
import { take } from 'rxjs/operators';
@Component({
  selector: 'app-sign-in-sign-up',
  templateUrl: './sign-in-sign-up.component.html',
  styleUrls: ['./sign-in-sign-up.component.scss'],
  providers: [ConfirmationService, MessageService, HeaderComponent, FilterService],
})
export class SignInSignUpComponent implements OnInit {
  referalModal: boolean = false; 
  refferalcodeAvailable: boolean = true; 
  refferalcodenotAvailable: boolean = false; 
  position: string = 'center';
  signUpForm: FormGroup;
  signUpForm2: FormGroup;
  loginForm: FormGroup;
  forgotPassForm: FormGroup;
  mobileLoginForm: FormGroup;
  submitted: boolean = false;
  loginFormSubmitted: boolean = false;
  genders;
  message;
  showMessage: boolean = false;
  selectedGender: any = null;
  userType;
  userData;
  isLoginFailed: boolean;
  isLoggedIn: boolean;
  roles;
  trainerRoleId;
  permissions: any[] = [];
  permissionArray: any[] = [];
  userTypeListArray: any[] = [];
  rolelist: any[] = [];
  errorMessage;;
  ipAddress;
  yearRange;
  minDateValue: Date;
  minYear = environment.minYear;
  showGenderError;
  public cityList: any[] = [];
  public selectedCityId;
  public selectedCityName;
  public mobileNumber;
  public showOtpForm: boolean = false;
  public successMessage;
  public activeIndex: number = 0;
  public showCategoryError: boolean = false;
  public countDown: Subscription;
  public counter;
  public tick;
  public userId;
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  public config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    required: true,
    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px'
    }
  };
  public otp: string;
  public showForgotPasswordForm: boolean = false;
  public showOtpErrors: boolean = false;
  public showOtpErrorsMsg: boolean = false;
  public showMobileLoginOtpForm: boolean = false;
  public showResendButton: boolean = false;
  public showMobileFormErrors: boolean = false;
  public mobileFormsErrors: boolean = false;
  public otpLoginErrors: boolean = false;
  public showOtpLoginErrors: boolean = false;
  public loading: boolean = false;
  public otpErrorMessage;
  public displayTime;
  public loggedInUser;
  public userCategories: any[] = [];
  public countrylist: any[] = [];
  public selectedCategory = undefined;
  public stateList: any[] = [];
  public countryName;
  public countryCode;
  public stateName;
  public stateCode;
  public cityName;
  public cityCode;
  public bannerImageList: any = [];
  parentcatList: any[] = [];
  public defaultDate: Date = new Date(environment.defaultDate);
  steps1: boolean = true;
  steps2: boolean = false;
  steps3: boolean = false;
  isChecked: boolean = false;
  countries: any[];
  showDiv: boolean = false;
  cascadeSelectCountries: any[];
  cities: any[];
  filteredCountries: any[];
  value1: any;
  value2: any;
  value3: any;
  value4: any;
  value5: any;
  value6: any;
  value7: any;
  value8: any;
  value9: any;
  value10: any;
  valueIconLeft: any;
  valueIconRight: any;
  value: string | undefined;
  isButtonActive: boolean = false;
  public signupFormSubmitted: boolean = false;
  public signup2Submitted: boolean = false;
  referalcodeupdate;
  constructor(
    private categoryService: CategoryService,
    private router: Router,
    private formBuilder: FormBuilder,
    private roleService: RoleService,
    private http: HttpClient,
    private headerComponent: HeaderComponent,
    private cityService: CityService,
    private userService: UserService,
    private countryService: CountryService,
    private stateService: StateService,
    private tokenStorage: TokenStorageService,
    private bannerService: BannerService,
    private authService: AuthService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private activatedRouter: ActivatedRoute,
    private renderer: Renderer2,
  ) { }
  ngOnInit(): void {
    this.router.navigateByUrl("/");
    // this.roleService.setCurrentActiveRoute2(this.router.url);
    // this.roleService.setCurrentActiveRoute(this.router.url);
    // this.renderer.addClass(document.body, 'login-page-body');
    // this.cities = [
    //   { name: "New York", code: "NY" },
    //   { name: "Rome", code: "RM" },
    //   { name: "London", code: "LDN" },
    //   { name: "Istanbul", code: "IST" },
    //   { name: "Paris", code: "PRS" }
    // ];


    // this.loginForm = this.formBuilder.group({
    //   email: ['', [Validators.required, Validators.email, CustomValidators.email]],
    //   password: ['', [Validators.required, Validators.minLength(6)]],
    //   rememberMe: [false],
    // });
    // this.signUpForm = this.formBuilder.group({
    //   mobileNumber: [null, {
    //     validators: [Validators.required, Validators.pattern("[0-9 ]{10}")], updateOn: 'blur'
    //   }],
    //   //role: ['player'],
    //   //userType: ['player']
    // }, {
    //   //validator: MustMatch('password', 'confirmPassword'),
    //   updateOn: "blur"
    // });

    // this.signUpForm2 = this.formBuilder.group({
    //   firstName: ['', {
    //     validators: [Validators.required, lettersWithOptionalSpaceValidator()], updateOn: 'blur'
    //   }],
    //   lastName: ['', {
    //     validators: [Validators.required, lettersWithOptionalSpaceValidator()], updateOn: 'blur'
    //   }],
    //   email: ['', {
    //     validators: [Validators.required, Validators.email, CustomValidators.email], updateOn: 'blur'
    //   }],
    //   referral: [''],
    //   referralYes: [],
    //   referralNo: []
    //   //role: ['player'],
    //   //userType: ['player']
    // }, {
    //   //validator: MustMatch('password', 'confirmPassword'),
    //   updateOn: "blur"
    // });
    // this.activatedRouter.queryParams.subscribe(params => {

    //   let referralCode = params['ref'];
    //   this.referalcodeupdate = referralCode

    //   if (referralCode != undefined) {

    //     this.showDiv = true;
    //     this.signUpForm2.controls.referral.setValue(referralCode);
    //     this.signUpForm2.controls.referral.disable();
    //   } else {
    //     this.showDiv = false;
    //     this.signUpForm2.controls.referral.enable();
    //   }
    // });
    // this.mobileLoginForm = this.formBuilder.group({
    //   mobileNumber: [null, [Validators.required, Validators.pattern("[0-9 ]{10}")]],
    // });
    // this.forgotPassForm = new FormGroup({
    //   email: new FormControl("", [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}")])
    // });
    // this.userCategories = environment.userCategories;
    // this.minDateValue = new Date();
    // this.yearRange = this.minYear + ":" + maxYearFunction();
    // this.userCategories.forEach(element => {
    //   this.signUpForm.addControl(element.slug, new FormControl());
    //   if (element.slug == "player") {
    //     this.selectedCategory = element.slug;
    //     this.signUpForm.get(element.slug).setValue(element.status);
    //   }
    // });

    // let url = this.router.url;
    // const container = document.getElementById('container');
    // const overlayContainer = document.getElementById('overlay_container');
    // let string = 'sign-up';
    // if (url === '/sign-up' || url.match(string) !== null) {
    //   container.classList.add("right-panel-active");
    //   overlayContainer.classList.add("overlay-container");
    // } else {
    //   container.classList.remove("right-panel-active");
    // }

    // if (url === '/sign-in') {
    //   container.classList.add("left-panel-active");
    //   overlayContainer.classList.add("overlay-container-right");
    // } else {
    //   container.classList.add("remove-panel-active");
    // }
  }
  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'login-page-body');
  }

  get f() {
    return this.signUpForm.controls;
  }
  get signupF() {
    return this.signUpForm2.controls;
  }
  get loginf() {
    return this.loginForm.controls;
  }
  get forgotPassValidation() {
    return this.forgotPassForm.controls;
  }
  get mobNumberFormValidation() {
    return this.mobileLoginForm.controls;
  }

  onMobilePhoneSubmit(mode) {
    let mobileData;
    if (mode != "resend") {
      this.submitted = true;
      //stop here if form is invalid
      if (this.mobileLoginForm.invalid) {
        return;
      }

      mobileData = this.mobileLoginForm.value.mobileNumber;
      this.mobileNumber = mobileData;
    } else {
      mobileData = this.mobileNumber
    }

    this.authService.generateMobileOtp(mobileData).subscribe(
      res => {

        this.showMobileLoginOtpForm = true;
        this.showResendButton = false;
        //this.timer(5);
        this.counter = 300;
        this.tick = 1000;
        this.otpTimer(this.counter, this.tick);
      }, err => {
        this.showMobileFormErrors = true;
        this.mobileFormsErrors = err.error.error;
        setTimeout(() => {
          this.showMobileFormErrors = false;
        }, 5000);
        this.showMobileLoginOtpForm = false;
      });
  }
  otpTimer(counter, tick) {
    this.countDown = timer(0, this.tick)
      .pipe(take(this.counter))
      .subscribe(() => {
        --this.counter;
        if (this.counter == 0) {
          this.showResendButton = true;
          this.countDown.unsubscribe();
        }
      });
  }
  signupOtpTimer(counter, tick) {
    this.countDown = timer(0, this.tick)
      .pipe(take(this.counter))
      .subscribe(() => {
        --this.counter;
        if (this.counter == 0) {
          this.showResendButton = true;
          this.countDown.unsubscribe();
        }
      });
  }
  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return (
      ('00' + minutes).slice(-2) +
      ':' +
      ('00' + Math.floor(value - minutes * 60)).slice(-2)
    );
  }
  onOtpChange(otp) {
    this.otp = otp;
    this.showMobileFormErrors = false;
    this.showOtpErrors = false;
    this.showOtpLoginErrors = false;
  }
  onClickOtpLoginSubmit() {
    if (this.otp == undefined || this.otp == '' || this.otp.length < 6) {
      this.showOtpErrors = true;
      this.showOtpLoginErrors = false;
      return;
    }
    let otpData = {
      'otp': this.otp,
      'mobileNumber': this.mobileNumber,
    }
    this.authService.otpLogin(otpData).subscribe(
      data => {
        this.userData = data;
        this.tokenStorage.saveToken(this.userData.data.access_token);
        this.tokenStorage.saveUser(this.userData.data);
        this.tokenStorage.getAuthStatus(this.userData.data);
        this.isLoginFailed = false;
        this.isLoggedIn = true;
        this.roles = this.tokenStorage.getUser().roles;
        this.getRoleDetails();
        this.getRoleList();
        this.getParentCategory();
        let academyPaymentDetails = this.userData.data.userdata.academyPaymentDetails;
        let roleName = this.userData.data.userdata.rolename;
        let currentUrl = '/refer-earn';
        if (roleName == "academy") {
          if (Object.keys(academyPaymentDetails).length > 0) {
            if (academyPaymentDetails.academyPaymentStatus == 'created') {
              currentUrl = '/payment-history';
            } else {
              currentUrl = '/refer-earn';
            }
          } else {
            currentUrl = '/payment-history';
          }
        } 
        // else {
        //   if (this.userData.data.userdata.isProfileComplete === false) {
        //     currentUrl = '/profile-edit';
        //   }
        // }
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
      },
      ((err) => {
        this.showOtpLoginErrors = true;
        this.otpLoginErrors = err.error.error;
      })
    );
  }
  onClickOtpSubmit() {
    if (this.otp == undefined || this.otp.length < 6) {
      this.showOtpErrors = true;
      return;
    }
    let otpData = {
      'otp': this.otp,
      'mobileNumber': this.mobileNumber,
    }
    this.authService.verifyOtp(otpData).subscribe(
      data => {

        // setTimeout(() => {
        // this.showMessage = true;
        // this.signUpForm.reset();
        // this.submitted = false;
        // this.showOtpForm = false;
        // this.showOtpErrors = false;
        // this.activeIndex = Number(0);
        // this.successMessage = 'Otp verified Successfully! Please login';
        // setTimeout(() => {
        //   this.showMessage = false;
        // }, 5000);
        // this.router.navigate(['/thankyou']);
        this.steps1 = false;
        this.steps2 = false;
        this.steps3 = true;
      },
      ((err) => {
        this.showOtpErrorsMsg = true;
        this.otpErrorMessage = err.error.error;
        setTimeout(() => {
          this.showOtpErrorsMsg = false;

        }, 5000);

      })
    );
  }
  onClickOtpback() {
    this.showMobileLoginOtpForm = false;
    this.showMobileFormErrors = false;
    this.showOtpErrors = false;
    this.showOtpLoginErrors = false;
    this.countDown.unsubscribe();
  }
  onClickSignUpOtpBack() {
    this.steps1 = true;
    this.steps2 = false;
    this.steps3 = false;
    this.showOtpErrors = false;
    this.showOtpLoginErrors = false;
    this.selectedCategory = undefined;
    this.userCategories.forEach(element => {
      this.signUpForm.addControl(element.slug, new FormControl());
      if (element.slug == "player") {
        this.selectedCategory = element.slug;
        this.signUpForm.get(element.slug).setValue(element.status);
      }
    });
    this.signUpForm.controls.mobileNumber.setValidators([Validators.required, Validators.pattern("[0-9 ]{10}")]);
    this.countDown.unsubscribe();
  }
  resendOtp() {
    let mode = 'resend';
    this.showMobileFormErrors = false;
    this.showOtpErrors = false;
    this.showOtpLoginErrors = false;
    this.otp = '';
    this.ngOtpInput.setValue(0);
    this.onMobilePhoneSubmit(mode);
  }

  onSubmit(): void {
    this.loginFormSubmitted = true;
    //stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }
    const username = this.loginForm.value.email;
    const password = this.loginForm.value.password;
    const rememberMeValue = this.loginForm.value.rememberMe;
    this.userType = "player";

    this.authService.login(username, password, this.userType, rememberMeValue).subscribe(
      data => {
        this.userData = data;
        this.userData.data.rememberMe = rememberMeValue;
        this.tokenStorage.saveToken(this.userData.data.access_token);
        this.tokenStorage.saveUser(this.userData.data);
        this.tokenStorage.getAuthStatus(this.userData.data);
        this.isLoginFailed = false;
        this.isLoggedIn = true;
        this.roles = this.tokenStorage.getUser().roles;
        this.getRoleDetails();
        this.getRoleList();
        this.getParentCategory();
        let academyPaymentDetails = this.userData.data.userdata.academyPaymentDetails;
        let roleName = this.userData.data.userdata.rolename;
        let isFromReferAndEarn = window.sessionStorage.getItem('isFromReferAndEarn');
        if (isFromReferAndEarn === 'true') {
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigateByUrl('refer-earn');
          return;
        }
        let currentUrl = '/';
        if (roleName == "academy") {
          if (Object.keys(academyPaymentDetails).length > 0) {
            if (academyPaymentDetails.academyPaymentStatus == 'created') {
              currentUrl = '/payment-history';
            } else {
              currentUrl = '/academies-profile';
            }
          } else {
            currentUrl = '/payment-history';
          }
        } else {
          if (this.userData.data.userdata.isProfileComplete === false) {
            currentUrl = '/profile-edit';
          }
        }

        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
      },
      error => {
        //throw Error();
        this.loginFormSubmitted = false;
        this.errorMessage = 'Login failed: Please check your login credentials...! ';
        // let currentUrl = '/sign-in';
        // // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        // // this.router.onSameUrlNavigation = 'reload';
        // // this.router.navigate([currentUrl]);
        this.isLoginFailed = true;
      }
    );
    //});
  }
  onSignupSubmit(): void {
    this.signupFormSubmitted = true;
    //stop here if form is invalid
    if (this.signUpForm.invalid) {
      return;
    }
    let userData = this.signUpForm.value;
    // if (this.selectedGender == null) {
    //   this.showGenderError = true;
    //   return;
    // }
    if (this.selectedCategory == undefined) {
      this.showCategoryError = true;
      return;
    }
    // userData['gender'] = this.selectedGender;
    // userData['countryname'] = this.countryName;
    // userData['countrycode'] = this.countryCode;
    // userData['statename'] = this.stateName;
    // userData['statecode'] = this.stateCode;
    // userData['citycode'] = this.selectedCityId;
    // userData['cityname'] = this.selectedCityName;
    // userData['role'] = this.selectedCategory;
    userData['status'] = true;
    if (this.selectedCategory === 'proplayer') {
      userData['status'] = false;
    }
    userData['userType'] = this.selectedCategory;
    this.mobileNumber = userData['mobileNumber'];
    delete userData['coach'];
    delete userData['proplayer'];
    delete userData['player'];
    delete userData['country'];
    delete userData['state'];
    delete userData['city'];
    this.authService.playerSignup(userData).subscribe(
      data => {
        //this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'User Added', life: 6000 });
        // setTimeout(() => {
        this.userId = data.id;
        this.showMessage = true;
        this.showOtpForm = true;
        this.signupFormSubmitted = false;
        this.signup2Submitted = false;
        this.steps1 = false;
        this.steps3 = false;
        this.steps2 = true;
        this.showResendButton = false;
        //this.timer(5);
        this.counter = 300;
        this.tick = 1000;
        this.signupOtpTimer(this.counter, this.tick);
        //this.message = 'User Added';
        setTimeout(() => {
          this.showMessage = false;
        }, 5000);
        this.signUpForm.reset();
        // this.userTypeError = false;
        //this.selectedGender = this.genders[0];
        //this.router.navigateByUrl("/sign-in");
        //}, 5000);
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: err.error.error, life: 6000 });
        this.showMessage = true;
        this.message = err.error.error;
        // setTimeout(() => {
        //   this.showMessage = false;
        // }, 5000);
        //this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add User Failed', life: 6000 });
      })
    );
  }
  onSignupSubmit2(): void {
    this.signup2Submitted = true;
    //stop here if form is invalid
    if (this.signUpForm2.invalid) {
      return;
    }
    let userData = this.signUpForm2.value;
    userData['firstName'] = userData.firstName.trim()
    userData['lastName'] = userData.lastName.trim()
    //console.log(this.referralCode,'ref')
    // if (this.selectedGender == null) {
    //   this.showGenderError = true;
    //   return;
    // }
    if (this.selectedCategory == undefined) {
      this.showCategoryError = true;
      return;
    }

    if (this.referalcodeupdate !== undefined) {
      userData['referral'] = this.referalcodeupdate;
    }

    // userData['role'] = this.selectedCategory;
    userData['status'] = true;
    if (this.selectedCategory === 'proplayer') {
      userData['status'] = false;
    }
    userData['userType'] = this.selectedCategory;
    //this.mobileNumber = userData['mobileNumber'];
    delete userData['coach'];
    delete userData['player'];
    delete userData['country'];
    delete userData['state'];
    delete userData['city'];
    this.authService.updateUser(this.userId, userData).subscribe(
      data => {
        //this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'User Added', life: 6000 });
        // setTimeout(() => {
        this.showMessage = true;
        this.showOtpForm = true;
        this.signupFormSubmitted = false;
        this.signup2Submitted = false;
        this.steps3 = false;
        this.steps2 = false;
        this.steps1 = true;
        this.showResendButton = false;
        //this.timer(5);
        //this.message = 'User Added';
        setTimeout(() => {
          this.showMessage = true;
        }, 1000);
        this.signUpForm2.reset();
        this.router.navigate(['/thankyou']);
        // this.userTypeError = false;
        //this.selectedGender = this.genders[0];
        //this.router.navigateByUrl("/sign-in");
        //}, 5000);
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: err.error.error, life: 6000 });
        this.showMessage = true;
        this.message = err.error.message;
        setTimeout(() => {
          this.showMessage = true;
        }, 1000);
        //this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Add User Failed', life: 6000 });
      })
    );
  }
  onClickForgotPassword() {
    this.showForgotPasswordForm = true;
  }
  onCheckboxChange(event: any) {
    this.isChecked = event;
  }
  onSignUpClick(): void {
    // const container = document.getElementById('container');
    // const overlayContainer = document.getElementById('overlay_container');
    // container.classList.add("right-panel-active");
    // container.classList.remove("left-panel-active");
    // overlayContainer.classList.add("overlay-container");
    // overlayContainer.classList.remove("overlay-container-right");
    this.router.navigate(['/']);
  }
  onSignInClick(): void {
    const container = document.getElementById('container');
    const overlayContainer = document.getElementById('overlay_container');
    container.classList.add("left-panel-active");
    container.classList.remove("right-panel-active");
    overlayContainer.classList.add("overlay-container-right");
    overlayContainer.classList.remove("overlay-container");

  }
  mobileForm() {
    this.steps1 = false;
    this.steps2 = true;
  }
  backOtpForm() {
    this.steps2 = false;
    this.steps1 = true;
  }
  otpForm() {
    this.steps2 = false;
    this.steps3 = true;
  }

  getRoleDetails() {
    const querystring = "filterByroleId=" + this.userData.data.userdata.role;
    this.roleService.getRoleListWithoutAuth(querystring).subscribe(
      data => {
        this.trainerRoleId = data.data.items[0]['id'];
        this.permissions = data.data.items[0]['permissions'];
        this.tokenStorage.saveUserPermissions(this.permissions);
        this.rolelist = data.data.items[0];
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
  findIndexByIdArray(name, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].rolename === name) {
        index = i;
        break;
      }
    }
    return index;
  }
  onForgotPassSubmit() {
    this.submitted = true;
    if (this.forgotPassForm.valid) {
      this.authService.requestPassword(this.forgotPassForm.value).subscribe(res => {
        if (res['errors']) {
          this.errorMessage = res['errors'];
          this.successMessage = '';
        } else {
          this.successMessage = res;
          this.errorMessage = '';
        }
        this.showMessage = true;
        setTimeout(() => {
          this.submitted = false;
          this.forgotPassForm.reset();
          this.showMessage = false;
          this.successMessage = '';
        }, 2000);
      },
        err => {
          this.successMessage = '';
          this.showMessage = true;
          this.errorMessage = err.error.data.errors;
        });
    }
  }
  onForgotPassBack() {
    this.showForgotPasswordForm = false;
  }
  getRoleList() {
    var querystring = "filterByDisable=false&filterByStatus=true";
    var rolearray = [];
    this.roleService.getRoleListWithoutAuth(querystring).subscribe(
      data => {
        var rolelist = data.data.items;
        rolelist.forEach(element => {
          rolearray.push({ "roleid": element.id, "rolename": element.user_role_name });
        });
        if (rolearray.length > 0) {
          this.tokenStorage.saveRolelist(rolearray);
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
  getParentCategory() {
    var query = "?filterByDisable=false&filterByStatus=true&getOnlyParent=true";
    this.categoryService.getCategoryList(query).subscribe(
      data => {
        this.parentcatList = data.data.items;
        this.tokenStorage.saveCategorylist(this.parentcatList);
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }

  onUserCategorySelect(userCategory, event) {
    this.selectedCategory = undefined;
    if (event.isTrusted) {
      this.selectedCategory = userCategory.slug;
      this.userCategories.forEach(element => {
        let obj = { slug: element.slug, name: element.name, status: element.status };
        if (this.selectedCategory == element.slug) {
          const index = this.findIndexBySlug(element.slug, this.userCategories);
          obj = { slug: element.slug, name: element.name, status: true };
          this.userCategories[index] = obj;
          this.signUpForm.get(element.slug).setValue(obj.status);
        } else {
          const index = this.findIndexBySlug(element.slug, this.userCategories);
          obj = { slug: element.slug, name: element.name, status: false };
          this.userCategories[index] = obj;
          //this.accountReportForm.get(element.name).setValue(reportObj);
        }
      })
    }
  }
  findIndexBySlug(slug, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].slug === slug) {
        index = i;
        break;
      }
    }
    return index;
  }
  showDialog(position: string) {
    this.position = position;
    this.referalModal = true;
}
referalCode() {
    this.refferalcodeAvailable = false; 
    this.refferalcodenotAvailable = true; 
    this.referalModal = false;
}

removeReferalcode(){
  this.refferalcodeAvailable = true; 
  this.refferalcodenotAvailable = false; 
}
}
